import { render, staticRenderFns } from "./TableCell.vue?vue&type=template&id=c94004aa&scoped=true"
import script from "./TableCell.vue?vue&type=script&lang=js"
export * from "./TableCell.vue?vue&type=script&lang=js"
import style0 from "./TableCell.vue?vue&type=style&index=0&id=c94004aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94004aa",
  null
  
)

export default component.exports